var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHorizontalObject = function SvgHorizontalObject(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99994 20.5001L9.99994 4.50049C9.99994 3.39592 9.10451 2.50049 7.99994 2.50049L4.00002 2.50049C2.89545 2.50049 2.00002 3.39592 2.00002 4.50049L2.00001 20.5001C2.00001 21.6047 2.89544 22.5001 4.00001 22.5001L7.99994 22.5001C9.10451 22.5001 9.99994 21.6047 9.99994 20.5001Z",
    stroke: "#495057",
    strokeWidth: 1.33,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9999 5.16667L21.9999 4.5C21.9999 3.39543 21.1045 2.5 19.9999 2.5L19.3333 2.5",
    stroke: "#495057",
    strokeWidth: 1.33,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9999 19.8333L21.9999 20.5C21.9999 21.6046 21.1045 22.5 19.9999 22.5L19.3333 22.5",
    stroke: "#495057",
    strokeWidth: 1.33,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 5.16667L13.9999 4.5C13.9999 3.39543 14.8954 2.5 15.9999 2.5L16.6666 2.5",
    stroke: "#495057",
    strokeWidth: 1.33,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 19.8333L13.9999 20.5C13.9999 21.6046 14.8954 22.5 15.9999 22.5L16.6666 22.5",
    stroke: "#495057",
    strokeWidth: 1.33,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9999 7.8335L21.9999 11.1668",
    stroke: "#495057",
    strokeWidth: 1.33,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9999 13.8335L21.9999 17.1668",
    stroke: "#495057",
    strokeWidth: 1.33,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 7.8335L13.9999 11.1668",
    stroke: "#495057",
    strokeWidth: 1.33,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 13.8335L13.9999 17.1668",
    stroke: "#495057",
    strokeWidth: 1.33,
    strokeLinecap: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHorizontalObject);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNCAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuOTk5OTQgMjAuNTAwMUw5Ljk5OTk0IDQuNTAwNDlDOS45OTk5NCAzLjM5NTkyIDkuMTA0NTEgMi41MDA0OSA3Ljk5OTk0IDIuNTAwNDlMNC4wMDAwMiAyLjUwMDQ5QzIuODk1NDUgMi41MDA0OSAyLjAwMDAyIDMuMzk1OTIgMi4wMDAwMiA0LjUwMDQ5TDIuMDAwMDEgMjAuNTAwMUMyLjAwMDAxIDIxLjYwNDcgMi44OTU0NCAyMi41MDAxIDQuMDAwMDEgMjIuNTAwMUw3Ljk5OTk0IDIyLjUwMDFDOS4xMDQ1MSAyMi41MDAxIDkuOTk5OTQgMjEuNjA0NyA5Ljk5OTk0IDIwLjUwMDFaIiBzdHJva2U9IiM0OTUwNTciIHN0cm9rZS13aWR0aD0iMS4zMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjxwYXRoIGQ9Ik0yMS45OTk5IDUuMTY2NjdMMjEuOTk5OSA0LjVDMjEuOTk5OSAzLjM5NTQzIDIxLjEwNDUgMi41IDE5Ljk5OTkgMi41TDE5LjMzMzMgMi41IiBzdHJva2U9IiM0OTUwNTciIHN0cm9rZS13aWR0aD0iMS4zMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjxwYXRoIGQ9Ik0yMS45OTk5IDE5LjgzMzNMMjEuOTk5OSAyMC41QzIxLjk5OTkgMjEuNjA0NiAyMS4xMDQ1IDIyLjUgMTkuOTk5OSAyMi41TDE5LjMzMzMgMjIuNSIgc3Ryb2tlPSIjNDk1MDU3IiBzdHJva2Utd2lkdGg9IjEuMzMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTMuOTk5OSA1LjE2NjY3TDEzLjk5OTkgNC41QzEzLjk5OTkgMy4zOTU0MyAxNC44OTU0IDIuNSAxNS45OTk5IDIuNUwxNi42NjY2IDIuNSIgc3Ryb2tlPSIjNDk1MDU3IiBzdHJva2Utd2lkdGg9IjEuMzMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTMuOTk5OSAxOS44MzMzTDEzLjk5OTkgMjAuNUMxMy45OTk5IDIxLjYwNDYgMTQuODk1NCAyMi41IDE1Ljk5OTkgMjIuNUwxNi42NjY2IDIyLjUiIHN0cm9rZT0iIzQ5NTA1NyIgc3Ryb2tlLXdpZHRoPSIxLjMzIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPHBhdGggZD0iTTIxLjk5OTkgNy44MzM1TDIxLjk5OTkgMTEuMTY2OCIgc3Ryb2tlPSIjNDk1MDU3IiBzdHJva2Utd2lkdGg9IjEuMzMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjEuOTk5OSAxMy44MzM1TDIxLjk5OTkgMTcuMTY2OCIgc3Ryb2tlPSIjNDk1MDU3IiBzdHJva2Utd2lkdGg9IjEuMzMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTMuOTk5OSA3LjgzMzVMMTMuOTk5OSAxMS4xNjY4IiBzdHJva2U9IiM0OTUwNTciIHN0cm9rZS13aWR0aD0iMS4zMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMy45OTk5IDEzLjgzMzVMMTMuOTk5OSAxNy4xNjY4IiBzdHJva2U9IiM0OTUwNTciIHN0cm9rZS13aWR0aD0iMS4zMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cjwvc3ZnPgo=";